import { Component, Input } from '@angular/core';
import { PatientsService } from '../patients.service';
import { ExamsService } from '../exams.service';
import { LoginService } from '../login.service';
import { Patient } from '../patients/patient';

@Component({
  selector: 'app-es-patient-card',
  templateUrl: './es-patient-card.component.html',
  styleUrls: ['./es-patient-card.component.scss'],
  standalone: false,
})
export class EsPatientCardComponent {
  /** Caller provides the patient to display. */
  @Input() pat: Patient;
  /** Show a warning badge on the add-button (e.g. missing DOB for NT exams). */
  @Input() addBtnWarning = false;
  /** Optional warning message rendered below the header. */
  @Input() warningMsg: string | null = null;
  /** Extra info rows beyond the standard ones — array of {label, value} pairs. */
  @Input() extraRows: { label: string; value: string }[] = [];

  constructor(
    public patService: PatientsService,
    public es: ExamsService,
    public login: LoginService
  ) {}
}
